export const MAX_NARRATIVE_FILE_SIZE_IN_MB = 500;
export const MAX_INTERACTION_FILE_SIZE_IN_MB = 2000;
export const MAX_AUDIO_DURATION_HOURS = 4;
export const MAX_AUDIO_DURATION_SECONDS = MAX_AUDIO_DURATION_HOURS * 60 * 60;